<template>
  <div style="min-height: calc(100vh - 70px);display: flex;">
    <section class="m-content m-content-full align-items-center">
      <div class="gate_center col">
        <form>
          <div class="row justify-content-center">
            <div class="card col-12 col-md-8 col-lg-5">
              <div class="card__title">
                <h3>Verify your phone number</h3>
              </div>
              <div class="card__body">
                <div class="row">
                  <p class="col-12 input--hint">
                    Enter six digit verification code sent
                    to {{$store.state.Auth.phonenumber}}
                    <br />
                    <!-- <a @click="$router.go(-1)" href="#">Change number?</!-->
                  </p>
                </div>
                <div class="row">
                  <div class="col-12 form-group m-form__group">
                    <pincode
                      class_name="pincode_wrapper"
                      v-bind:input="pincodes"
                      name="pincode"
                      v-on:onFishied="onFishied"
                      ref="verifyPincode"
                    />
                  </div>
                </div>
              </div>
              <div class="card__footer">
                <p class="col-12 input--hint text-center">
                  Didn't get the code?
                  <a @click.prevent="fetchPage()" href="#">Resend SMS</a>
                </p>
                <div
                  v-if="$store.state.Auth.is_new_user == 'true'|| $store.state.Auth.is_new_user === true || $store.state.Auth.is_fcr_user == 'true' || $store.state.Auth.is_fcr_user === true"
                  class="steps_icons text-center"
                >
                  <span class="m-badge m-badge--dot"></span>
                  <span class="m-badge m-badge--dot"></span>
                  <span class="m-badge m-badge--dot"></span>
                  <span class="m-badge m-badge--dot active"></span>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
    <div class="m-gate_bg gate_bg_not_mobile m-gate_bg--top-down">
      <img
        class="m-gate_bg__top"
        src="./../../../public/assets/demo/default/media/img/misc/m-gate_bg__top.png"
        alt
      />
      <img
        class="m-gate_bg__down"
        src="./../../../public/assets/demo/default/media/img/misc/m-gate_bg__top.png"
        alt
      />
    </div>
  </div>
</template>
<script>
import pincode from "../../components/pincode";

export default {
  props: {
    isFetchPage: {
      default: true
    }
  },
  data: () => ({
    phone: null,
    pincodes: ["", "", "", "", "", ""],
    password: null
  }),
  mounted() {
    if (this.isFetchPage) {
      this.fetchPage();
    }
    $("body")
      .removeClass("m--bg-white")
      .addClass(
        "m-page--fluid m--skin- m-content--skin-light2 m-header--fixed m-header--fixed-mobile m-aside-left--disable"
      );
    $(".m-brand--skin-light").addClass("m-brand--skin-light2");
  },
  methods: {
    fetchPage() {
      this.$store.dispatch("loader", true);
      this.$store
        .dispatch("requestOTP")
        .catch(error => {
          this.$swal({
            imageUrl: "/images/svg/Error.svg",
            title: error.message
          });
        })
        .finally(() => {
          this.$store.dispatch("loader", false);
        });
    },
    onFishied() {
      this.Verify()
    },
    Verify() {
      if (this.pincodes.join("").length !== 6) {
        this.$swal({
          imageUrl: "/images/svg/Error.svg",
          title: "Invalid verification code."
        });
      } else {
        const queryParams = this.$route.query;
        const redirectedFrom = queryParams && queryParams["redirect-from"];
        this.$store.dispatch("loader", true);
        this.$store
          .dispatch("verifyOTP", { otp: this.pincodes.join("") })
          .then(response => {
            let tokenData = {
              browserAuthToken: response.response.data.browserAuthToken
            };
            this.$store.dispatch("saveToken", tokenData);
            // this.$router.push({name: 'dashboard'})
            if (
              this.$store.state.Auth.is_new_user == "true" ||
              this.$store.state.Auth.is_new_user === true
            ) {
              this.$store.dispatch("redirect", "dashboard");
            } else if (
              this.$store.state.Auth.is_fcr_user == "true" ||
              this.$store.state.Auth.is_fcr_user === true
            ) {
              this.$store.dispatch("redirect", "credit-report");
            } else if (redirectedFrom) {
              this.$store.dispatch("loader", false);
              this.$store.dispatch("redirect", redirectedFrom);
            } else {
              this.$store.dispatch("redirect", {
                name: "wallet",
                params: { ref: "from-login" }
              });
            }
          })
          .catch(error => {
            this.password = null;
            this.pincodes = ["", "", "", "", "", ""];
            this.$store.dispatch("handleError", {...error, pincodeRef: this.$refs.verifyPincode});
          })
          .finally(() => {
            this.$store.dispatch("loader", false);
          });
      }
    }
  },
  components: {
    pincode
  }
};
</script>
